const WALLPAPER_FILE_REF_PREFIX = "file:";

const UUID_V4_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const normalizeCandidate = (value: string): string => value.trim();

const isUuid = (value: string): boolean => UUID_V4_PATTERN.test(value);

export const parseWallpaperFileId = (value: string): string | null => {
  const candidate = normalizeCandidate(value);
  if (!candidate) {
    return null;
  }

  if (candidate.startsWith(WALLPAPER_FILE_REF_PREFIX)) {
    const fileId = normalizeCandidate(
      candidate.slice(WALLPAPER_FILE_REF_PREFIX.length),
    );

    return isUuid(fileId) ? fileId : null;
  }

  return isUuid(candidate) ? candidate : null;
};

export const toWallpaperFileRef = (fileId: string): string =>
  `${WALLPAPER_FILE_REF_PREFIX}${fileId}`;
